import { Link, redirect, useLocation } from 'react-router-dom';
import profile from "../../../studentassets/images/avatar/profile.png";
import icon14 from "../../../studentassets/images/icons/14.png";
import { useSelector } from 'react-redux';
import { selectMode } from '../../../service/slice/ThemeSlice';
import { BiHomeAlt } from "react-icons/bi";
import { IoSettingsOutline } from "react-icons/io5";
import { FaRegUser } from "react-icons/fa";
import { MdOutlineLogout } from "react-icons/md";
import { MdPayment } from "react-icons/md";
import { BsCloudDownload } from "react-icons/bs";
import { MdLocalActivity } from "react-icons/md";
import { useState } from 'react';
import icon03 from "../../../studentassets/images/icons/free.png";



export default function LeftSidebar() {

    const userDetails = useSelector((state) => state?.userSlice?.value)
    const [first_name, setFirstName] = useState(userDetails?.first_name);
    const [last_name, setLastName] = useState(userDetails?.last_name);
    const [email, setEmail] = useState(userDetails?.email);
    const [openMenu, setOpenMenu] = useState(null);

    const toggleMenu = (menuName) => {
        setOpenMenu(openMenu === menuName ? null : menuName);
    };

    const theme = useSelector(selectMode);
    const sidebar = useSelector((state) => state.theme.sideBar);
    const userSubscription = useSelector((state) => state?.userSlice?.userSubscription)

    const themeColor = {
        color: theme === 'light' ? '#000' : '#fff',
        background: theme === 'light' ? '#fff' : '#151A24',
        boxShadow: theme === 'light' ? '#fff' : 'rgb(186 189 217 / 20%)',
    };

    function handleLogout() {
        localStorage.removeItem("authToken");
        window.location.href = "/";
    }

    const { pathname } = useLocation();
    console.log(pathname.split('/user/')[1])

    return (
        <>
            <div className={`${sidebar && "left-side-bar-open"} left-side-bar`} style={themeColor}>
                <div className="inner">
                    <div className="single-menu-wrapper">
                        <Link to="/user/dashboard" className={`${sidebar && "single-menu-open"} single-menu ${pathname.split('/user/')[1] == 'dashboard' && 'selected'}`} style={themeColor}>
                            <div className="icon">
                                <BiHomeAlt style={themeColor} />
                            </div>
                            <p style={{ color: theme === 'light' ? '#000' : '#FFFF' }}>Home</p>
                        </Link>
                    </div>

                    <div className="single-menu-wrapper">

                        {/* Activity Section */}
                        <Link to="/user/activity" className={`${sidebar && "single-menu-open"} single-menu ${pathname.split('/user/')[1] == 'activity' && 'selected'}`} style={themeColor}>
                            <div className="icon">
                                <MdLocalActivity style={{ fontSize: "22px" }} />
                            </div>
                            <p style={themeColor}>Activity</p>
                        </Link>

                        {/* Profile Section */}
                        <Link to="/user/packagehistory" className={`${sidebar && "single-menu-open"} single-menu ${pathname.split('/user/')[1] == 'packagehistory' && 'selected'}`} style={themeColor}>
                            <div className="icon">
                                <MdPayment style={{ fontSize: "22px" }} />
                            </div>
                            <p style={{ color: theme === 'light' ? '#000' : '#FFFF' }}>Package</p>
                        </Link>


                        {/* Profile Section */}
                        <Link to="/user/editprofile" className={`${sidebar && "single-menu-open"} single-menu ${pathname.split('/user/')[1] == 'editprofile' && 'selected'}`} style={themeColor}>
                            <div className="icon">
                                <FaRegUser style={{ fontSize: "22px" }} />
                            </div>
                            <p style={themeColor}>Profile</p>
                        </Link>

                        {/* Settings Button */}
                        {/* <div className="sidebar">
                            <Link className={`collapse-btn single-menu ${openMenu === "Settings" ? "open" : ""} ${pathname.split('/user/')[1] == 'dashboard' && 'selected'}`} role="button" onClick={() => { toggleMenu("Settings") }} style={themeColor}>
                                <div className="icon">
                                    <IoSettingsOutline style={themeColor} />
                                </div>
                                <p style={themeColor}>Settings</p>
                            </Link>

                            {openMenu === "Settings" && (
                                <div className="submenu-container">
                                    <ul className="submenu rts-default-sidebar-list">
                                        <li>
                                            <Link to="#" style={themeColor}>
                                                <span>Download</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div> */}


                        {/* Logout */}
                        <Link onClick={() => { handleLogout() }} className={`${sidebar && "single-menu-open"} single-menu`} style={themeColor}>
                            <div className="icon">
                                <MdOutlineLogout style={{ fontSize: "22px" }} />
                            </div>
                            <p style={{ color: theme === 'light' ? '#000' : '#FFFF' }}>Logout</p>
                        </Link>

                    </div>
                </div>

                <div className={`${sidebar && "bottom-user-open"} bottom-user`} style={{ background: theme === 'dark' ? '#121B32' : '#FFFF', }}>
                    <div className="user-wrapper">
                        <img src={profile} alt="avatar" height="40" width="40" />
                        <div className={`${sidebar && "d-block"} info`}>
                            <h6 className="title" style={themeColor}>{first_name + " " + last_name}</h6>
                            <p style={{ ...themeColor, fontSize: "11px" }} >{email}</p>
                        </div>
                        {/* <span>Free</span> */}
                    </div>
                    <div className={`${sidebar && "d-block"} pro-upgrade`}>
                        {userSubscription ?
                            <Link to="/user/packagehistory">
                                <button className="rts-btn btn-primary">
                                    <img src={icon14} alt="icons" />
                                    {userSubscription?.name}
                                </button>
                            </Link>
                            :
                            <Link to="/user/packagehistory">
                                <button className="rts-btn btn-primary">
                                    <img src={icon03} alt="icons" style={{ height: "30px" }} />
                                    upgrade now
                                </button>
                            </Link>}
                    </div>
                </div>
            </div>
        </>
    )
}
